<template>
  <div>
    <v-btn icon title="Visualizar resultado da exportação para o Protheus" @click="dialog_ativo = true">
      <v-icon>mdi-file-eye</v-icon>
    </v-btn>

    <dialog-resultado-exportacao v-model="dialog_ativo" :resultado="resultado_exportacao" />
  </div>
</template>

<script setup>
import {ref, watch} from "vue";
import * as req from "@/api/drp/pedido";
import {logout} from "@/helpers";
import store from "@/store";
import DialogResultadoExportacao from "@/components/drp/separacaoDeMercadorias/exportacaoProtheus/DialogResultadoExportacao.vue";

const props = defineProps({
  pedido: Object
});

const dialog_ativo = ref(false);
const resultado_exportacao = ref({})

watch(dialog_ativo, () => {
  if (!dialog_ativo.value || resultado_exportacao.value.pedidos) return;
  buscarResultadoExportcaoProtheus();
});

function buscarResultadoExportcaoProtheus() {
  store.dispatch('loading/addRequisicao',
    req.buscarResultadoExportcaoProtheus(props.pedido.idpedido)
      .then(({exportacao}) => resultado_exportacao.value = exportacao)
      .catch(logout)
  );
}
</script>

<style scoped>

</style>
